import { StackingMode } from 'src/app/utils/echarts/apply-stacking-mode';
import { IDashboardItemPersistentOptions } from '../../services/dashboard-item/dashboard-item-persistent-options.model';

/**
 * Interface for ECharts DashboardItem settings. It is used to store ECharts DashboardItem settings in the database.
 */
export interface IEChartsDashboardItemPersistentOptions extends IDashboardItemPersistentOptions {
    chartType?: 'table' | 'chart';
    seriesType?: 'line' | 'bar';
    /** Whether to stack series */
    stackingMode?: StackingMode;
}

/** Minimal presentation options shared by XY, Flow and future ECharts item factories. */
export interface IEChartsDashboardItemPresentationOptions {
    echartsSeriesType?: 'line' | 'bar';
    stackingMode?: StackingMode;
}

/** Persisted user choices override factory defaults for every ECharts item type. */
export function effectiveEChartsDashboardItemOptions<
    T extends IEChartsDashboardItemPresentationOptions,
>(
    initOptions: T,
    persistentOptions: IEChartsDashboardItemPersistentOptions
): T {
    return {
        ...initOptions,
        echartsSeriesType:
            persistentOptions.seriesType ?? initOptions.echartsSeriesType,
        stackingMode:
            persistentOptions.stackingMode ?? initOptions.stackingMode,
    };
}
